import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appDropdown]',
    exportAs: 'appDropdown',
    standalone: true
})
export class DropdownDirective {
    @Input() appDropdown = '';

    get isOpen(): boolean {
        return this.el.nativeElement.classList.contains(this.appDropdown);
    }

    constructor(private el: ElementRef<HTMLElement>) {
    }

    @HostListener('window:click', ['$event'])
    onWindowClick(event: Event): void {

        if (!this.isOpen) {
            return;
        }

        const path = event.composedPath ? event.composedPath() : [];
        const clickedInside = path.includes(this.el.nativeElement);

        if (!clickedInside) {
            this.close();
        } else {
        }
    }

    toggle(force?: boolean): void {
        const targetState = force !== undefined ? force : !this.isOpen;
        this.el.nativeElement.classList.toggle(this.appDropdown, targetState);
    }

    close(): void { this.toggle(false); }
    open(): void { this.toggle(true); }
}
